import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import NumberedCitationConverterCommand from './numberedcitationconvertercommand';

export default class NumberedCitationConverterEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add('numberedcitationconverter', new NumberedCitationConverterCommand(editor, 'numberedcitationconverter'));
  }
}